import { useInfiniteQuery } from 'react-query'
import { getAcceptedDemandLoans, TDecidedSort } from 'services/loans'

export default function useGetAcceptedDemandLoans(
    id: string | undefined,
    sort: TDecidedSort = 'decided_newest'
) {
    const { data, isLoading, fetchNextPage, refetch } = useInfiniteQuery(
        ['money-pools-fund-loans-accepted', id, sort],
        ({ pageParam = 1 }) => getAcceptedDemandLoans(pageParam, id, sort),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord = allPages[allPages.length - 1]?.next || ''
                return lastRecord
                    ? new URL(lastRecord).searchParams.get('page')
                    : undefined
            },
        }
    )
    return {
        demandLoans: data,
        isLoadingDemandLoans: isLoading,
        refetch,
        fetchNextPage,
    }
}
